import './index.css';
import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import { Provider as ReduxProvider } from 'react-redux';
import { LocalizationProvider } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { configureStore } from './Store';
import { App } from './App';
import { ScrollToTop } from './ScrollToTop';
import reportWebVitals from './reportWebVitals';

const store = configureStore();

ReactDOM.render(
    <HelmetProvider>
        <ReduxProvider store={store}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <BrowserRouter>
                    <ScrollToTop />
                    <App />
                </BrowserRouter>
            </LocalizationProvider>
        </ReduxProvider>
    </HelmetProvider>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals())
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
